'use client';

import Button from 'components/shared/Buttons/BaseButton';
import { CTA_LABEL, ENROLLMENT_URL, START_OVER_LABEL } from './constants';

interface OverdraftCalculatorResultProps {
  onStartOver: () => void;
}

/** The saving itself is announced by the shell's summary; this is what to do about it. */
export const OverdraftCalculatorResult = ({ onStartOver }: OverdraftCalculatorResultProps) => (
  <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
    <Button href={ENROLLMENT_URL}>{CTA_LABEL}</Button>
    <Button type="button" variant="outline" onClick={onStartOver}>
      {START_OVER_LABEL}
    </Button>
  </div>
);
